// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as SessionsType$OrcaPaymentPage from "../Types/SessionsType.bs.js";
import * as ClickToPayHelpers$OrcaPaymentPage from "../Types/ClickToPayHelpers.bs.js";

function useClickToPay(areClickToPayUIScriptsLoaded, setSessions, setAreClickToPayUIScriptsLoaded, savedMethods, loadSavedCards) {
  var match = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.clickToPayConfig);
  var setClickToPayConfig = match[1];
  var clickToPayConfig = match[0];
  var setShowPaymentMethodsScreen = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  var clickToPayProvider = clickToPayConfig.clickToPayProvider;
  var isReady = clickToPayConfig.isReady;
  var setClickToPayProvider = function (provider) {
    setClickToPayConfig(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.clickToPayProvider = provider;
          return newrecord;
        });
  };
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var sessionsObj = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.sessions);
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var clientSecret = match$1.clientSecret;
  var closeComponentIfSavedMethodsAreEmpty = function () {
    if (savedMethods.length === 0 && loadSavedCards !== "LoadingSavedCards") {
      return setShowPaymentMethodsScreen(function (param) {
                  return true;
                });
    }
    
  };
  var setClickToPayNotReady = function () {
    setClickToPayConfig(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.isReady = false;
          return newrecord;
        });
  };
  var getVisaCards = async function (identityValue, otp, identityType) {
    var consumerIdentity_identityProvider = "SRC";
    var consumerIdentity_identityValue = identityType === "EMAIL_ADDRESS" ? identityValue : identityValue.replaceAll(" ", "");
    var consumerIdentity = {
      identityProvider: consumerIdentity_identityProvider,
      identityType: identityType,
      identityValue: consumerIdentity_identityValue
    };
    var getCardsConfig = otp.length === 6 ? ({
          consumerIdentity: consumerIdentity,
          validationData: otp
        }) : ({
          consumerIdentity: consumerIdentity
        });
    try {
      var cardsResult = await ClickToPayHelpers$OrcaPaymentPage.getCardsVisaUnified(getCardsConfig);
      var match = cardsResult.actionCode;
      var exit = 0;
      switch (match) {
        case "SUCCESS" :
            var profilesArray = cardsResult.profiles;
            var cards;
            if (profilesArray !== undefined) {
              loggerState.setLogInfo(Core__Option.getOr(JSON.stringify({
                            message: "Cards fetched successfully",
                            scheme: clickToPayProvider
                          }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
              var profile = profilesArray[0];
              cards = profile !== undefined ? profile.maskedCards : undefined;
            } else {
              cards = undefined;
            }
            setClickToPayConfig(function (prev) {
                  var newrecord = Caml_obj.obj_dup(prev);
                  newrecord.visaComponentState = "NONE";
                  return newrecord;
                });
            return setClickToPayConfig(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.clickToPayCards = cards;
                        return newrecord;
                      });
        case "PENDING_CONSUMER_IDV" :
            return setClickToPayConfig(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.maskedIdentity = Core__Option.getOr(cardsResult.maskedValidationChannel, "");
                        newrecord.visaComponentState = "OTP_INPUT";
                        return newrecord;
                      });
        case "FAILED" :
        case "ERROR" :
            exit = 1;
            break;
        case "ADD_CARD" :
            return setClickToPayConfig(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.visaComponentState = "NONE";
                        return newrecord;
                      });
        
      }
      if (exit === 1) {
        if (otp !== "") {
          var err = cardsResult.error;
          if (err === undefined) {
            return setClickToPayConfig(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.visaComponentState = "NONE";
                        return newrecord;
                      });
          }
          var reason = err.reason;
          if (reason === undefined) {
            return setClickToPayConfig(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.visaComponentState = "NONE";
                        return newrecord;
                      });
          }
          switch (reason) {
            case "ACCT_INACCESSIBLE" :
                loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                              message: "Maximum getCard call attempts reached (ACCT_INACCESSIBLE) - " + reason,
                              scheme: clickToPayProvider
                            }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                return setClickToPayConfig(function (prev) {
                            var newrecord = Caml_obj.obj_dup(prev);
                            newrecord.otpError = "ACCT_INACCESSIBLE";
                            return newrecord;
                          });
            case "OTP_SEND_FAILED" :
                loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                              message: "OTP SEND FAILED",
                              scheme: clickToPayProvider
                            }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                return setClickToPayConfig(function (prev) {
                            var newrecord = Caml_obj.obj_dup(prev);
                            newrecord.otpError = "NONE";
                            return newrecord;
                          });
            case "VALIDATION_DATA_INVALID" :
                return setClickToPayConfig(function (prev) {
                            var newrecord = Caml_obj.obj_dup(prev);
                            newrecord.otpError = "VALIDATION_DATA_INVALID";
                            return newrecord;
                          });
            default:
              setClickToPayConfig(function (prev) {
                    var newrecord = Caml_obj.obj_dup(prev);
                    newrecord.otpError = "NONE";
                    return newrecord;
                  });
              return loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                                  message: "get cards call failed - " + reason,
                                  scheme: clickToPayProvider
                                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
          }
        } else {
          setClickToPayConfig(function (prev) {
                var newrecord = Caml_obj.obj_dup(prev);
                newrecord.visaComponentState = "NONE";
                return newrecord;
              });
          return loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                              message: "initial get cards call failed",
                              scheme: clickToPayProvider
                            }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
        }
      }
      
    }
    catch (raw_err){
      var err$1 = Caml_js_exceptions.internalToOCamlException(raw_err);
      setClickToPayNotReady();
      return loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                          message: "get cards call failed - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err$1)),
                          scheme: clickToPayProvider
                        }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    }
  };
  var initVisaUnified = async function (email) {
    try {
      var token = clickToPayConfig.clickToPayToken;
      if (token === undefined) {
        return ;
      }
      var initConfig = ClickToPayHelpers$OrcaPaymentPage.getVisaInitConfig(token, clientSecret);
      setClickToPayConfig(function (prev) {
            var newrecord = Caml_obj.obj_dup(prev);
            newrecord.visaComponentState = "CARDS_LOADING";
            return newrecord;
          });
      await window.VSDK.initialize(initConfig);
      await getVisaCards(email, "", "EMAIL_ADDRESS");
      return ;
    }
    catch (raw_err){
      var err = Caml_js_exceptions.internalToOCamlException(raw_err);
      setClickToPayNotReady();
      closeComponentIfSavedMethodsAreEmpty();
      return loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                          message: "SDK initialization failed - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                          scheme: clickToPayProvider
                        }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    }
  };
  var getClickToPayToken = function (ssn) {
    var dict = Utils$OrcaPaymentPage.getDictFromJson(ssn);
    var clickToPaySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "ClickToPayObject");
    var match = SessionsType$OrcaPaymentPage.getPaymentSessionObj(clickToPaySessionObj.sessionsToken, "ClickToPay");
    if (match.TAG === "ClickToPayTokenOptional") {
      var token = match._0;
      if (token !== undefined) {
        setClickToPayConfig(function (prev) {
              var newrecord = Caml_obj.obj_dup(prev);
              newrecord.clickToPayToken = ClickToPayHelpers$OrcaPaymentPage.clickToPayTokenItemToObjMapper(token);
              return newrecord;
            });
        return ClickToPayHelpers$OrcaPaymentPage.clickToPayTokenItemToObjMapper(token);
      } else {
        setClickToPayNotReady();
        return ;
      }
    }
    setClickToPayNotReady();
  };
  var loadVisaScript = async function (ctpToken) {
    try {
      ClickToPayHelpers$OrcaPaymentPage.loadClickToPayUIScripts(loggerState, (function () {
              setAreClickToPayUIScriptsLoaded(function (param) {
                    return true;
                  });
            }), setClickToPayNotReady);
      if (ctpToken !== undefined) {
        return ClickToPayHelpers$OrcaPaymentPage.loadVisaScript(ctpToken, (function () {
                      if (ctpToken !== undefined) {
                        return setClickToPayConfig(function (prev) {
                                    var newrecord = Caml_obj.obj_dup(prev);
                                    newrecord.dpaName = ctpToken.dpaName;
                                    newrecord.email = ctpToken.email;
                                    newrecord.availableCardBrands = ctpToken.cardBrands;
                                    newrecord.isReady = true;
                                    return newrecord;
                                  });
                      } else {
                        return setClickToPayNotReady();
                      }
                    }), (function () {
                      setClickToPayNotReady();
                      loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                                    message: "CTP UI script loading failed",
                                    scheme: clickToPayProvider
                                  }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                    }));
      } else {
        return setClickToPayNotReady();
      }
    }
    catch (raw_err){
      var err = Caml_js_exceptions.internalToOCamlException(raw_err);
      setClickToPayNotReady();
      return loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                          message: "CTP UI script loading failed - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                          scheme: clickToPayProvider
                        }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    }
  };
  var loadMastercardClickToPayScript = function (ctpToken) {
    if (ctpToken !== undefined) {
      Core__Promise.$$catch(ClickToPayHelpers$OrcaPaymentPage.loadClickToPayScripts(loggerState).then(function () {
                setAreClickToPayUIScriptsLoaded(function (param) {
                      return true;
                    });
                return Promise.resolve();
              }), (function (param) {
              loggerState.setLogError("ClickToPay UI Kit CSS Load Error", "CLICK_TO_PAY_SCRIPT", undefined, undefined, undefined, undefined, undefined);
              return Promise.resolve();
            }));
      Core__Promise.$$catch(ClickToPayHelpers$OrcaPaymentPage.loadMastercardScript(ctpToken, loggerState).then(function (resp) {
                var availableCardBrands = Utils$OrcaPaymentPage.getArray(Utils$OrcaPaymentPage.getDictFromJson(resp), "availableCardBrands").map(function (item) {
                        return Core__Option.getOr(Core__JSON.Decode.string(item), "");
                      }).filter(function (item) {
                      return item !== "";
                    });
                setClickToPayConfig(function (prev) {
                      var newrecord = Caml_obj.obj_dup(prev);
                      newrecord.dpaName = ctpToken.dpaName;
                      newrecord.email = ctpToken.email;
                      newrecord.availableCardBrands = availableCardBrands;
                      newrecord.isReady = true;
                      return newrecord;
                    });
                return Promise.resolve();
              }), (function (param) {
              setClickToPayNotReady();
              return Promise.resolve();
            }));
      return ;
    } else {
      return setClickToPayNotReady();
    }
  };
  React.useEffect((function () {
          if (Caml_obj.equal(isReady, true) && clickToPayProvider === "VISA" && areClickToPayUIScriptsLoaded && Core__Option.isSome(clickToPayConfig.clickToPayToken)) {
            initVisaUnified(clickToPayConfig.email);
          }
          
        }), [
        isReady,
        areClickToPayUIScriptsLoaded,
        clickToPayProvider,
        clickToPayConfig.clickToPayToken
      ]);
  React.useEffect((function () {
          if (clickToPayConfig.email !== "" && clickToPayConfig.consumerIdentity.identityValue === "") {
            setClickToPayConfig(function (prev) {
                  var newrecord = Caml_obj.obj_dup(prev);
                  newrecord.consumerIdentity = {
                    identityType: "EMAIL_ADDRESS",
                    identityValue: clickToPayConfig.email
                  };
                  return newrecord;
                });
          }
          
        }), [clickToPayConfig.email]);
  React.useEffect((function () {
          if (Caml_obj.equal(isReady, true) && clickToPayProvider === "MASTERCARD") {
            ((async function () {
                    try {
                      var cardsResult = await ClickToPayHelpers$OrcaPaymentPage.getCards(loggerState);
                      if (cardsResult.TAG !== "Ok") {
                        return ;
                      }
                      var cards = cardsResult._0;
                      return setClickToPayConfig(function (prev) {
                                  var newrecord = Caml_obj.obj_dup(prev);
                                  newrecord.clickToPayCards = cards;
                                  return newrecord;
                                });
                    }
                    catch (exn){
                      return ;
                    }
                  })());
          }
          
        }), [
        isReady,
        clickToPayProvider
      ]);
  React.useEffect((function () {
          if (typeof sessionsObj === "object" && sessionsObj.TAG === "Loaded") {
            var ssn = sessionsObj._0;
            setSessions(function (param) {
                  return ssn;
                });
            var ctpToken = getClickToPayToken(ssn);
            Core__Option.forEach(ctpToken, (function (token) {
                    var match = token.provider.toLowerCase();
                    switch (match) {
                      case "mastercard" :
                          loadMastercardClickToPayScript(ctpToken);
                          return setClickToPayProvider("MASTERCARD");
                      case "visa" :
                          loadVisaScript(ctpToken);
                          return setClickToPayProvider("VISA");
                      default:
                        setClickToPayNotReady();
                        return setClickToPayProvider("NONE");
                    }
                  }));
          }
          
        }), [sessionsObj]);
  return [
          getVisaCards,
          closeComponentIfSavedMethodsAreEmpty
        ];
}

export {
  useClickToPay ,
}
/* react Not a pure module */
